import z from "zod";

export const renameFileSchema = z.object({
	newPath: z.string().min(1, "New path is required"),
});
